import { useSelector, shallowEqual } from "react-redux";
import withRouter from "app/utils/hocs/withRouter";
import { getBrandDisplayName, getFooterData } from "app/reducers/partnerSelector";
import { getContextCallCenter } from "app/pages/Booking/bookingSelectors";
import { getCurrentContextualizedSignupPage } from "app/pages/SignupPage/Auth/SignupAuthSelector";

import Footer from "@brand/Footer/default/Footer";
import { isWhiteLabel } from "app/reducers/brandSelector";

const mapStateToProps = (state, ownProps) => {
	const contextCallCenter = getContextCallCenter({})(state);
	const { location } = ownProps;
	const isMerchPage = location.pathname.includes("/merch");
	const displayPhone = contextCallCenter.displayPhone || [];
	const footer = getFooterData(state);

	return {
		shop: state.shop,
		signupPageAuth: getCurrentContextualizedSignupPage(state),
		helpContactUrl: contextCallCenter.helpContactUrl,
		preSalesPlanningUrl: state.callCenter.preSalesPlanningUrl,
		displayPhone,
		cgvDocumentName: state.documents.cgv,
		legalesDocumentName: state.documents.legales,
		confidentialiteDocumentName: state.documents.confidentialite,
		partnerCode: state.partner.code,
		showConfigureCookieLink: Boolean(state.partner.technicalVars?.ONE_TRUST_SCRIPT),
		isMerchPage,
		resolution: state.resolution,
		brand: state.brand.code,
		paymentMethods: state.partner.availablePaymentMethods,
		additionalNote: footer.additionalNote,
		showReassurancePayment: footer.showReassurancePayment,
		useSVA: footer.useSVA,
		showShopSwitcher: footer.showShopSwitcher,
		showPfsMessage: footer.showPfsMessage,
		feedbackLink: footer.feedbackLink,
		additionalLinks: footer.additionalLinks,
		socialNetworksLinks: footer.socialNetworks,
		partnerRedirectionLink: footer.partnerRedirectionLink,
		brandDisplayName: getBrandDisplayName(state),
		brandCode: state.brand.code,
		isWhiteLabel: isWhiteLabel(state),
		hideContactUsSection: state.partner?.hideContactUsSection,
		cookiePolicyDocument: state.documents?.cookiePolicy,
		cguDocument: state.documents?.cgu,
	};
};

const FooterContainer = props => {
	const stateProps = useSelector(state => mapStateToProps(state, props), shallowEqual);
	return <Footer {...props} {...stateProps} />;
};

export default withRouter(FooterContainer);
